(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrima-coach"] && !Shopify.designMode) return;
  try {
    
  class NutrimaCoach extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-panel]');
      if (!this.panel || this.ready) return;
      this.ready = true;
      this.log = this.querySelector('[data-log]');
      this.input = this.querySelector('[data-input]');
      this.sendButton = this.querySelector('[data-send]');
      this.opener = this.querySelector('[data-open]');
      this.storageKey = 'nutrima-coach';
      this.turns = this.load();
      this.busy = false;
      this.restored = false;

      this.opener.addEventListener('click', () => this.open());
      this.querySelector('[data-close]').addEventListener('click', () => this.close());
      this.querySelector('[data-reset]').addEventListener('click', () => this.reset());
      this.querySelector('[data-form]').addEventListener('submit', (event) => {
        event.preventDefault();
        this.ask(this.input.value);
      });
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && !event.shiftKey && !event.isComposing) {
          event.preventDefault();
          this.ask(this.input.value);
        }
      });
      this.input.addEventListener('input', () => {
        this.input.style.height = 'auto';
        this.input.style.height = `${Math.min(this.input.scrollHeight, 104)}px`;
      });
      this.addEventListener('keydown', (event) => event.key === 'Escape' && !this.panel.hidden && this.close());
      this.querySelectorAll('[data-chip]').forEach((chip) => chip.addEventListener('click', () => this.ask(chip.textContent)));
      this.gate = this.querySelector('[data-gate-form]');
      if (this.gate) this.gate.addEventListener('submit', (event) => this.signUp(event));
    }

    // The chat opens once per browser, after a sign-up here, in the quiz or in the exit offer.
    locked() {
      if (!this.gate || !this.dataset.gate) return false;
      try {
        return !(localStorage.getItem('nutrima-coach-ok') || localStorage.getItem('nutrima-welcome'));
      } catch {
        return false;
      }
    }

    showGate(show) {
      if (!this.gate) return;
      this.gate.hidden = !show;
      this.log.hidden = show;
      this.querySelector('[data-form]').hidden = show;
    }

    async signUp(event) {
      event.preventDefault();
      const field = this.gate.querySelector('[data-email]');
      const error = this.gate.querySelector('[data-gate-error]');
      const button = this.gate.querySelector('[data-gate-submit]');
      const email = field.value.trim();
      const valid = /^[^@\s]+@[^@\s]+\.[A-Za-z]{2,}$/.test(email);
      error.hidden = valid;
      field.setAttribute('aria-invalid', valid ? 'false' : 'true');
      if (!valid) return field.focus();
      button.disabled = true;
      let response = null;
      let referral = '';
      try { referral = localStorage.getItem('nutrima-ref') || ''; } catch { /* private mode */ }
      try {
        response = await fetch(`${this.dataset.gateway.replace(/\/$/, '')}/v1/web-leads`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email,
            phone: null,
            first_name: null,
            email_consent: true,
            sms_consent: false,
            consent_text: this.dataset.consent,
            // The quiz fills in the real goal later.
            profile: { goal: 'undecided', diet: 'none', training_days: 0, sleep_hours: 7, sex: null, age_range: null, interests: ['capture:coach', `lang:${this.dataset.lang}`] },
            referral_code: referral || null,
            website: this.gate.elements.website.value,
          }),
        });
      } catch { /* offline: handled below */ }
      button.disabled = false;
      if (response && response.status === 422) {
        error.hidden = false;
        field.setAttribute('aria-invalid', 'true');
        return field.focus();
      }
      // A gateway hiccup should not stand between a shopper and the chat.
      const data = response && response.ok ? await response.json().catch(() => ({})) : {};
      try {
        localStorage.setItem('nutrima-coach-ok', '1');
        if (data.discount_code) {
          localStorage.setItem('nutrima-welcome', JSON.stringify({ code: data.discount_code, percent: data.percent, expires: data.discount_expires_at || null }));
        }
      } catch { /* private mode */ }
      this.showGate(false);
      if (data.discount_code) {
        this.bubble('coach', this.dataset.tCode.replace('%code%', data.discount_code).replace('%percent%', data.percent));
      }
      this.input.focus({ preventScroll: true });
    }

    load() {
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.storageKey) || '[]');
        return Array.isArray(saved) ? saved.filter((turn) => turn && typeof turn.content === 'string').slice(-10) : [];
      } catch {
        return [];
      }
    }

    save() {
      try { sessionStorage.setItem(this.storageKey, JSON.stringify(this.turns.slice(-10))); } catch { /* private mode */ }
    }

    open() {
      this.panel.hidden = false;
      this.classList.add('nutrima-coach--open');
      this.opener.setAttribute('aria-expanded', 'true');
      if (this.locked()) {
        this.showGate(true);
        this.gate.querySelector('[data-email]').focus({ preventScroll: true });
        return;
      }
      this.showGate(false);
      if (!this.restored) {
        this.restored = true;
        if (this.turns.length) this.querySelector('[data-chips]').hidden = true;
        this.turns.forEach((turn, index) => {
          this.bubble(turn.role === 'user' ? 'you' : 'coach', turn.content);
          if (turn.products && turn.products.length) this.cards(turn.products);
          if (index === this.turns.length - 1 && turn.options) this.options(turn.options);
        });
      }
      this.input.focus({ preventScroll: true });
      this.scrollDown();
    }

    close() {
      this.panel.hidden = true;
      this.classList.remove('nutrima-coach--open');
      this.opener.setAttribute('aria-expanded', 'false');
      this.opener.focus({ preventScroll: true });
    }

    reset() {
      if (this.busy) return;
      this.turns = [];
      this.save();
      [...this.log.children].forEach((node) => node.hasAttribute('data-intro') || node.hasAttribute('data-chips') || node.remove());
      this.quick = null;
      this.querySelector('[data-chips]').hidden = false;
      this.input.focus({ preventScroll: true });
    }

    bubble(kind, text) {
      const bubble = document.createElement('div');
      bubble.className = `nutrima-coach__msg nutrima-coach__msg--${kind}`;
      bubble.textContent = text;
      this.log.append(bubble);
      this.scrollDown();
      return bubble;
    }

    // Tap-to-answer replies under the coach's question; they go once one is used.
    options(list) {
      if (this.quick) this.quick.remove();
      this.quick = null;
      const texts = (Array.isArray(list) ? list : []).filter((text) => typeof text === 'string' && text.trim()).slice(0, 4);
      if (!texts.length) return;
      const row = document.createElement('div');
      row.className = 'nutrima-coach__chips';
      texts.forEach((text) => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'nutrima-coach__chip';
        chip.textContent = text.slice(0, 40);
        chip.addEventListener('click', () => this.ask(chip.textContent));
        row.append(chip);
      });
      this.log.append(row);
      this.quick = row;
      this.scrollDown();
    }

    scrollDown() {
      this.log.scrollTop = this.log.scrollHeight;
    }

    async ask(raw) {
      const text = (raw || '').trim().slice(0, 600);
      if (!text || this.busy) return;
      this.busy = true;
      this.sendButton.disabled = true;
      this.input.value = '';
      this.input.style.height = 'auto';
      this.querySelector('[data-chips]').hidden = true;
      this.options([]);
      this.bubble('you', text);
      this.turns.push({ role: 'user', content: text });

      const typing = this.bubble('coach', '');
      typing.setAttribute('aria-label', this.dataset.tTyping);
      typing.innerHTML = '<span class="nutrima-coach__typing"><span></span><span></span><span></span></span>';

      try {
        const body = { messages: this.turns.slice(-10).map(({ role, content }) => ({ role, content: content.slice(0, role === 'user' ? 600 : 1500) })), lang: this.dataset.lang };
        if (this.dataset.viewing) body.product = this.dataset.viewing;
        const response = await fetch(`${this.dataset.gateway.replace(/\/$/, '')}/v1/coach`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await response.json().catch(() => ({}));
        typing.remove();
        if (!response.ok || typeof data.reply !== 'string') {
          // The gateway's own wording for limits (429) is shown; anything else gets the generic line.
          this.turns.pop();
          this.bubble('error', response.status === 429 && typeof data.detail === 'string' ? data.detail : this.dataset.tError);
        } else {
          const products = Array.isArray(data.products) ? data.products.filter((handle) => /^[a-z0-9][a-z0-9-]*$/.test(handle)).slice(0, 3) : [];
          this.bubble('coach', data.reply);
          const options = Array.isArray(data.options) ? data.options : [];
          this.turns.push({ role: 'assistant', content: data.reply, products, options });
          if (products.length) this.cards(products);
          else this.options(options);
        }
      } catch {
        typing.remove();
        this.turns.pop();
        this.bubble('error', this.dataset.tError);
      }
      this.save();
      this.busy = false;
      this.sendButton.disabled = false;
    }

    // Cards come from this store's own product data, never from the reply.
    async cards(handles) {
      const row = document.createElement('div');
      row.className = 'nutrima-coach__cards';
      this.log.append(row);
      const root = this.dataset.root.replace(/\/?$/, '/');
      const products = await Promise.all(handles.map((handle) =>
        fetch(`${root}products/${handle}.js`, { headers: { Accept: 'application/json' } })
          .then((response) => (response.ok ? response.json() : null))
          .catch(() => null)));
      products.filter((product) => product && product.handle).forEach((product) => row.append(this.card(product, root)));
      if (!row.children.length) row.remove();
      this.scrollDown();
    }

    // Tells the theme the cart changed, the way its own product form does: the header count
    // and any open cart drawer listen for this event and wait on its promise.
    announceCart(variantId, sections) {
      const event = new Event('shopify:cart:lines-update', { bubbles: true, cancelable: true });
      event.action = 'add';
      event.context = 'product';
      event.lines = [{ quantity: 1, merchandiseId: `gid://shopify/ProductVariant/${variantId}` }];
      event.promise = fetch(`${this.dataset.basketUrl.replace(/\/$/, '')}.js`, { headers: { Accept: 'application/json' } })
        .then((response) => response.json())
        .then((cart) => ({
          cart: { totalQuantity: cart.item_count },
          detail: { items: cart.items, source: 'nutrima-coach', itemCount: 1, sections, didError: false },
        }));
      event.promise.catch(() => {});
      document.dispatchEvent(event);
    }

    card(product, root) {
      const url = `${root}products/${product.handle}`;
      const card = document.createElement('article');
      card.className = 'nutrima-coach__card';
      const image = document.createElement('img');
      image.alt = '';
      image.loading = 'lazy';
      image.width = 64;
      image.height = 64;
      if (product.featured_image) image.src = `${product.featured_image}${product.featured_image.includes('?') ? '&' : '?'}width=160`;
      const title = document.createElement('a');
      title.className = 'nutrima-coach__card-title';
      title.href = url;
      title.textContent = product.title;
      const price = document.createElement('p');
      price.className = 'nutrima-coach__card-price';
      try {
        price.textContent = new Intl.NumberFormat(this.dataset.lang, { style: 'currency', currency: this.dataset.currency }).format(product.price / 100);
      } catch {
        price.textContent = (product.price / 100).toFixed(2);
      }
      const actions = document.createElement('div');
      actions.className = 'nutrima-coach__card-actions';
      const view = document.createElement('a');
      view.href = url;
      view.textContent = this.dataset.tView;
      actions.append(view);
      const variant = (product.variants || []).find((item) => item.available);
      if (variant) {
        const add = document.createElement('button');
        add.type = 'button';
        add.textContent = this.dataset.tAdd;
        add.addEventListener('click', async () => {
          add.disabled = true;
          try {
            // Ask for the theme's cart sections in the same request, so the drawer and the
            // cart page can redraw themselves from the answer.
            const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')].map((item) => item.dataset.sectionId);
            const response = await fetch(`${root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }], sections: sectionIds.join(','), sections_url: window.location.pathname }),
            });
            if (!response.ok) throw new Error('add failed');
            const added = await response.json().catch(() => ({}));
            const cart = document.createElement('a');
            cart.href = this.dataset.basketUrl;
            cart.textContent = `${this.dataset.tAdded} ✓`;
            add.replaceWith(cart);
            this.announceCart(variant.id, added.sections);
          } catch {
            window.location.href = url;
          }
        });
        actions.append(add);
      }
      card.append(image, title, price, actions);
      return card;
    }
  }
  if (!customElements.get('nutrima-coach')) customElements.define('nutrima-coach', NutrimaCoach);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrima-colour-field"] && !Shopify.designMode) return;
  try {
    
  class NutrimaColourField extends HTMLElement {
    connectedCallback() {
      const gallery = document.querySelector('.product-information__media slideshow-container');
      if (!gallery || gallery.querySelector('.nutrima-cf__stage')) return;

      const stage = document.createElement('div');
      stage.className = 'nutrima-cf__stage';
      stage.setAttribute('aria-hidden', 'true');
      // left %, top %, width px, height px, rotation, colour
      const pills = [[6, 14, 30, 14, -20, 0], [84, 10, 24, 11, 30, 1], [3, 62, 20, 20, 0, 2], [88, 56, 36, 16, 55, 0], [16, 86, 26, 12, -35, 1], [72, 90, 16, 16, 0, 2], [30, 3, 14, 14, 0, 2], [60, 1, 28, 13, 15, 0]];
      const colours = ['#0f3d2e', '#fffdf8', '#e2603a'];
      stage.innerHTML =
        '<span class="nutrima-cf__disc"></span><span class="nutrima-cf__ring"></span>' +
        pills
          .map(([x, y, w, h, r, c], i) => `<span class="nutrima-cf__pill" style="left:${x}%;top:${y}%;width:${w}px;height:${h}px;background:${colours[c]};--r:${r}deg;--dx:${i % 2 ? 10 : -10}px;--dy:${-10 - i * 2}px;--t:${5 + i}s;--d:${i * -0.7}s"></span>`)
          .join('');
      gallery.prepend(stage);
      [['a', this.dataset.factA], ['b', this.dataset.factB]].forEach(([slot, text]) => {
        if (!text) return;
        const badge = document.createElement('span');
        badge.className = `nutrima-cf__badge nutrima-cf__badge--${slot}`;
        badge.textContent = text;
        gallery.append(badge);
      });

      // The photo leans towards the pointer; touch screens keep the gentle float only.
      if (!matchMedia('(hover: hover)').matches || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      gallery.addEventListener('pointermove', (event) => {
        const box = gallery.getBoundingClientRect();
        gallery.style.setProperty('--cf-ry', `${(((event.clientX - box.left) / box.width - 0.5) * 22).toFixed(1)}deg`);
        gallery.style.setProperty('--cf-rx', `${((0.5 - (event.clientY - box.top) / box.height) * 16).toFixed(1)}deg`);
      });
      gallery.addEventListener('pointerleave', () => {
        gallery.style.setProperty('--cf-ry', '0deg');
        gallery.style.setProperty('--cf-rx', '0deg');
      });
    }
  }
  if (!customElements.get('nutrima-colour-field')) customElements.define('nutrima-colour-field', NutrimaColourField);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrima-offer-layer"] && !Shopify.designMode) return;
  try {
    
  class NutrimaOfferLayer extends HTMLElement {
    connectedCallback() {
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' });
      this.welcome();
      this.calculator();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    /** The code this browser was given at sign-up: { code, percent, expires } or null. */
    saved() {
      try {
        const data = JSON.parse(localStorage.getItem('nutrima-welcome') || 'null');
        return data && typeof data.code === 'string' && data.code ? data : null;
      } catch {
        return null;
      }
    }

    welcome() {
      const saved = this.saved();
      const ends = saved && saved.expires ? Date.parse(saved.expires) : NaN;
      const expired = Number.isFinite(ends) && ends <= Date.now();
      // The invite is rendered by default; a saved code takes its place.
      if (!saved || expired) return;
      this.querySelector('[data-quiz-bar]').hidden = true;
      const bar = this.querySelector('[data-code-bar]');
      const line = this.dataset.tCode.split('%code%');
      const codeLine = bar.querySelector('[data-code-line]');
      const strong = document.createElement('strong');
      strong.textContent = saved.code;
      codeLine.append(line[0].replace('%percent%', saved.percent || 15).replace(/<\/?strong>/g, ''), strong, (line[1] || '').replace(/<\/?strong>/g, ''));
      bar.hidden = false;

      const copy = bar.querySelector('[data-copy]');
      copy.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(saved.code);
        } catch {
          return; // no clipboard access: the code stays readable on screen
        }
        const label = copy.querySelector('[data-copy-label]');
        const before = label.textContent;
        label.textContent = this.dataset.tCopied;
        bar.querySelector('[data-copy-status]').textContent = this.dataset.tCopied;
        setTimeout(() => { label.textContent = before; }, 2000);
      });

      if (!Number.isFinite(ends)) return; // a shared code has no end, so no timer
      const when = new Date(ends).toLocaleString(this.dataset.locale || 'en', { weekday: 'long', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit' });
      const endsNode = bar.querySelector('[data-ends]');
      endsNode.textContent = this.dataset.tEnds.replace('%date%', when);
      endsNode.hidden = false;
      const clock = bar.querySelector('[data-clock]');
      clock.hidden = false;
      clock.setAttribute('aria-label', endsNode.textContent);
      const tick = () => {
        const left = Math.max(0, Math.floor((ends - Date.now()) / 1000));
        const parts = { days: Math.floor(left / 86400), hours: Math.floor((left % 86400) / 3600), min: Math.floor((left % 3600) / 60), sec: left % 60 };
        Object.entries(parts).forEach(([unit, value]) => { clock.querySelector(`[data-unit="${unit}"]`).textContent = String(value).padStart(2, '0'); });
        if (left === 0) {
          clearInterval(this.timer);
          bar.hidden = true;
          this.querySelector('[data-quiz-bar]').hidden = false;
        }
      };
      tick();
      this.timer = setInterval(tick, 1000);
    }

    calculator() {
      const range = this.querySelector('[data-months]');
      if (!range) return;
      const once = Number(this.dataset.once);
      const first = Number(this.dataset.first);
      const later = Number(this.dataset.later);
      const show = () => {
        const months = Number(range.value);
        const onceTotal = once * months;
        const subTotal = first + later * (months - 1);
        this.querySelector('[data-months-label]').textContent = months === 1 ? this.dataset.tMonth : this.dataset.tMonths.replace('%count%', months);
        this.querySelector('[data-once-total]').textContent = this.money.format(onceTotal / 100);
        this.querySelector('[data-sub-total]').textContent = this.money.format(subTotal / 100);
        this.querySelector('[data-saved]').textContent = this.money.format((onceTotal - subTotal) / 100);
      };
      range.addEventListener('input', show);
      show();
    }
  }
  if (!customElements.get('nutrima-offer-layer')) customElements.define('nutrima-offer-layer', NutrimaOfferLayer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrima-quiz"] && !Shopify.designMode) return;
  try {
    
  // Without this script every step is shown stacked and the form posts
  // natively, so the quiz still works; the script adds one-step-at-a-time
  // navigation, tags, and the gateway path.
  class NutrimaQuiz extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.results = this.querySelector('[data-results]');
      if (!this.form || !this.results) return;
      this.storageKey = 'nutrima-quiz';
      this.steps = [...this.querySelectorAll('[data-step]')];
      this.index = 0;
      this.back = this.querySelector('[data-back]');
      this.next = this.querySelector('[data-next]');
      this.submit = this.querySelector('[data-submit]');
      this.classList.add('nutrima-quiz--js');
      this.querySelector('[data-progress]').hidden = false;

      this.back.addEventListener('click', () => this.go(this.index - 1));
      this.next.addEventListener('click', () => this.validateStep() && this.go(this.index + 1));
      this.form.addEventListener('submit', (event) => this.onSubmit(event));
      // Shopify's bot protection hooks the submit event of customer forms and
      // re-submits them itself. When the gateway takes the lead, no native
      // submit may fire at all, so the button stops being a submit button.
      if (this.dataset.gateway) {
        this.submit.type = 'button';
        this.submit.addEventListener('click', () => this.dataset.gateway && this.onSubmit());
        this.form.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' || event.target.tagName !== 'INPUT' || !this.dataset.gateway) return;
          event.preventDefault();
          this.index === this.steps.length - 1 ? this.onSubmit() : this.next.click();
        });
      }
      const phone = this.form.elements.quiz_phone;
      if (phone) phone.addEventListener('input', () => { this.querySelector('[data-sms-row]').hidden = !phone.value.trim(); });
      // Tapping an answer moves on by itself. Keyboard users change radios with
      // the arrow keys (those clicks have detail 0), so they keep the Continue button.
      this.querySelectorAll('[data-advance] input[type="radio"]').forEach((radio) => {
        radio.addEventListener('click', (event) => {
          if (!event.detail || this.index === this.steps.length - 1) return;
          const from = this.index;
          setTimeout(() => { if (this.index === from && this.validateStep()) this.go(from + 1, false); }, 220);
        });
      });

      this.querySelector('[data-retake]').addEventListener('click', () => this.retake());
      const copy = this.querySelector('[data-copy-code]');
      if (copy) copy.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(this.querySelector('[data-code-value]').textContent.trim());
        } catch {
          return; // no clipboard access: the code stays readable on screen
        }
        const before = copy.textContent;
        copy.textContent = copy.dataset.copied;
        this.querySelector('[data-copy-status]').textContent = copy.dataset.copied;
        setTimeout(() => { copy.textContent = before; }, 2000);
      });
      this.referral(); // remember an invite code even if the visitor browses before signing up

      if (!this.results.hidden) return this.showResults(this.saved());
      // Already did the quiz (in the app, by email link, or here before): skip
      // straight to their picks instead of asking again.
      const known = this.knownGoal();
      if (known) return this.showResults({ goal: known, caution: false }, undefined, false);
      // Came back from Shopify with a server-side error: show the contact step.
      this.go(this.querySelector('[data-server-error]') ? this.steps.length - 1 : 0, false);
    }

    saved() {
      try { return JSON.parse(localStorage.getItem(this.storageKey) || '{}'); } catch { return {}; }
    }

    /**
     * A goal we already know, in order of trust: the signed-in customer's
     * goal tag, a ?goal= link (app and email links carry it), then a quiz
     * finished earlier in this browser. Only goals this section offers count.
     */
    knownGoal() {
      const offered = [...this.querySelectorAll('[data-goal-result]')].map((node) => node.dataset.goalResult);
      const candidates = [this.dataset.knownGoal, new URLSearchParams(location.search).get('goal'), this.saved().done ? this.saved().goal : ''];
      return candidates.find((goal) => goal && offered.includes(goal)) || '';
    }

    /** A friend's invite code from a ?ref= link, remembered for this browser. */
    referral() {
      const fromUrl = (new URLSearchParams(location.search).get('ref') || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 12);
      try {
        if (fromUrl) localStorage.setItem('nutrima-ref', fromUrl);
        return fromUrl || localStorage.getItem('nutrima-ref') || '';
      } catch {
        return fromUrl;
      }
    }

    retake() {
      try { localStorage.removeItem(this.storageKey); } catch {}
      this.dataset.knownGoal = '';
      this.results.hidden = true;
      this.form.hidden = false;
      this.querySelector('[data-progress]').hidden = false;
      this.go(0);
    }

    answers() {
      const f = this.form.elements;
      return {
        goal: f.quiz_goal.value,
        diet: f.quiz_diet.value || 'none',
        sex: f.quiz_sex.value,
        age: f.quiz_age.value,
        train: Number(f.quiz_train.value),
        caution: f.quiz_caution.checked,
      };
    }

    go(index, focus = true) {
      this.index = Math.max(0, Math.min(index, this.steps.length - 1));
      this.steps.forEach((step, i) => { step.hidden = i !== this.index; });
      const last = this.index === this.steps.length - 1;
      this.back.hidden = this.index === 0;
      this.next.hidden = last;
      this.submit.hidden = !last;
      const percent = Math.round((this.index / (this.steps.length - 1)) * 100);
      const progress = this.querySelector('[data-progress-track]');
      progress.setAttribute('aria-valuenow', percent);
      progress.setAttribute('aria-valuetext', (this.dataset.tStep || '').replace('%current%', this.index + 1).replace('%total%', this.steps.length));
      progress.querySelector('[data-progress-bar]').style.width = Math.max(percent, 6) + '%';
      this.querySelector('[data-count]').textContent = `${this.index + 1} / ${this.steps.length}`;
      if (focus) (this.steps[this.index].querySelector('input, select') || this.steps[this.index]).focus({ preventScroll: false });
    }

    validateStep() {
      const step = this.steps[this.index];
      const error = step.querySelector('[data-error]');
      const ok = [...step.querySelectorAll('input[required]')].every((input) => {
        if (input.type === 'radio') return !!this.form.elements[input.name].value;
        if (input.type === 'checkbox') return input.checked;
        return true;
      });
      if (error) error.hidden = ok;
      return ok;
    }

    static phone(value) {
      const trimmed = value.trim();
      if (!trimmed) return '';
      const digits = trimmed.replace(/\D/g, '');
      if (trimmed.startsWith('+')) return digits.length >= 8 && digits.length <= 15 ? '+' + digits : null;
      if (digits.length === 10) return '+1' + digits;
      if (digits.length === 11 && digits.startsWith('1')) return '+' + digits;
      return null;
    }

    fieldError(name, show, message) {
      const node = this.querySelector(`[data-field-error="${name}"]`);
      if (!node) return;
      if (message) node.textContent = message;
      node.hidden = !show;
      const input = node.parentElement.querySelector('input');
      if (input) input.setAttribute('aria-invalid', show ? 'true' : 'false');
    }

    async onSubmit(event) {
      const f = this.form.elements;
      const firstName = f['contact[first_name]'].value.trim();
      const email = f['contact[email]'].value.trim();
      const phoneField = this.querySelector('nutrima-phone');
      const phone = phoneField && phoneField.e164 ? phoneField.e164() : f.quiz_phone ? NutrimaQuiz.phone(f.quiz_phone.value) : '';
      const emailOk = /^[^@\s]+@[^@\s]+\.[A-Za-z]{2,}$/.test(email);
      this.fieldError('first_name', !firstName);
      this.fieldError('email', !emailOk);
      this.fieldError('phone', phone === null);
      if (!firstName || !emailOk || phone === null) return event?.preventDefault();

      const a = this.answers();
      const tags = ['nutrima-quiz', 'signup:web', `goal:${a.goal}`, `diet:${a.diet}`, `age:${a.age}`, `train:${a.train}d`];
      const ref = this.referral();
      if (ref) tags.push(`ref:${ref}`);
      if (a.sex !== 'unspecified') tags.push(`sex:${a.sex}`);
      this.querySelector('[data-tags]').value = tags.join(',');
      try { localStorage.setItem(this.storageKey, JSON.stringify({ ...a, done: true })); } catch {}

      const gateway = this.dataset.gateway;
      if (!gateway) return; // native Shopify form submit; the page reloads with results

      event?.preventDefault();
      const label = this.querySelector('[data-submit-label]');
      const original = label.textContent;
      this.submit.disabled = true;
      label.textContent = this.dataset.tSaving || '…';
      const sms = !!(phone && f.quiz_sms && f.quiz_sms.checked);
      // Only a gateway that cannot be reached falls back to Shopify's own form,
      // so the lead is not lost. Anything after a successful save must never
      // re-submit the form.
      let response;
      try {
        response = await fetch(gateway.replace(/\/$/, '') + '/v1/web-leads', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email,
            phone: phone || null,
            first_name: firstName,
            email_consent: true,
            sms_consent: sms,
            consent_text: [this.dataset.emailConsent, sms ? this.dataset.smsConsent : ''].filter(Boolean).join(' | '),
            // The storefront language becomes a customer tag, so emails can follow it later.
            profile: { goal: a.goal, diet: a.diet, training_days: a.train, sleep_hours: 7, sex: a.sex, age_range: a.age, interests: this.dataset.lang && this.dataset.lang !== 'en' ? [`lang:${this.dataset.lang.toLowerCase()}`] : [] },
            referral_code: ref || null,
            website: f.quiz_website.value,
          }),
        });
      } catch {
        response = null;
      }
      this.submit.disabled = false;
      label.textContent = original;
      if (response && response.status === 422) {
        const problem = await response.json().catch(() => ({}));
        const field = ['email', 'phone', 'first_name'].includes(problem.field) ? problem.field : 'email';
        // The gateway explains the problem in English; other languages get the translated line.
        const english = (this.dataset.lang || 'en') === 'en';
        this.fieldError(field, true, (english && problem.detail) || this.dataset.tFieldError);
        return;
      }
      if (!response || !response.ok) {
        // Hand over to Shopify's own form (and its bot protection).
        this.dataset.gateway = '';
        this.submit.type = 'submit';
        this.form.requestSubmit(this.submit);
        return;
      }
      const body = await response.json().catch(() => ({}));
      // Product pages show this code again, with a countdown when it has a real end time.
      try {
        localStorage.setItem('nutrima-welcome', JSON.stringify({ code: body.discount_code || this.dataset.code, percent: body.percent || 15, expires: body.discount_expires_at || null }));
      } catch {}
      this.showResults(a, body.discount_code);
    }

    /**
     * Show the few products of the matched goal that also fit the dietary
     * preference. With no preference, or when nothing fits, the goal's top
     * products are shown and the note says so.
     */
    pickProducts(node, diet) {
      const shown = 3;
      const items = [...node.querySelectorAll('[data-pick]')];
      const wanted = diet && diet !== 'none' ? diet : '';
      const fits = wanted ? items.filter((item) => item.dataset.diets.split(' ').includes(wanted)) : [];
      const picks = (fits.length ? fits : items).slice(0, shown);
      items.forEach((item) => { item.hidden = !picks.includes(item); });
      const note = node.querySelector('[data-match-note]');
      if (!note) return;
      // The diet is named the way the quiz named it, in the shopper's language.
      const option = wanted && this.querySelector(`input[name="quiz_diet"][value="${wanted}"]`);
      const label = option ? option.closest('label').textContent.trim().toLocaleLowerCase() : wanted;
      const template = !wanted ? note.dataset.plain : fits.length ? note.dataset.diet : note.dataset.none;
      note.textContent = template.replace('%diet%', label);
    }

    showResults(a, code, scroll = true) {
      this.form.hidden = true;
      this.querySelector('[data-progress]').hidden = true;
      this.results.hidden = false;
      if (code) this.querySelectorAll('[data-code-value]').forEach((node) => { node.textContent = code; });
      const caution = !!a.caution;
      this.querySelector('[data-caution-note]').hidden = !caution;
      const cautionPicks = this.querySelector('[data-caution-picks]');
      if (cautionPicks) cautionPicks.hidden = !caution;
      // With nothing else to show, the welcome code would point at supplements.
      const codeRow = this.querySelector('[data-code-row]');
      if (codeRow) codeRow.hidden = caution && !cautionPicks;
      this.querySelectorAll('[data-goal-result]').forEach((node) => {
        node.hidden = caution || node.dataset.goalResult !== a.goal;
        if (!node.hidden) this.pickProducts(node, a.diet);
      });
      if (!scroll) return;
      this.results.focus();
      this.results.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }
  if (!customElements.get('nutrima-quiz')) customElements.define('nutrima-quiz', NutrimaQuiz);

  // Hero product stage: products lean towards the pointer, nearer ones further.
  (() => {
    const stage = document.querySelector('[data-stage]');
    if (!stage || !matchMedia('(hover: hover)').matches || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    stage.addEventListener('pointermove', (event) => {
      const box = stage.getBoundingClientRect();
      stage.style.setProperty('--px', (((event.clientX - box.left) / box.width - 0.5) * 2).toFixed(2));
      stage.style.setProperty('--py', (((event.clientY - box.top) / box.height - 0.5) * 2).toFixed(2));
    });
    stage.addEventListener('pointerleave', () => {
      stage.style.setProperty('--px', '0');
      stage.style.setProperty('--py', '0');
    });
  })();

  // Home page: sections below the hero ease in as they are scrolled to. Nothing is hidden
  // unless this script runs, and anything already on screen is left alone.
  (() => {
    const hero = document.querySelector('.nutrima-quiz--hero');
    if (!hero || !('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const own = hero.closest('.shopify-section');
    if (!own || !own.parentElement) return;
    const seen = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('nutrima-reveal--in');
        seen.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
    [...own.parentElement.children].forEach((section) => {
      if (section === own || !section.classList.contains('shopify-section') || !section.offsetHeight) return;
      if (section.getBoundingClientRect().top < innerHeight) return;
      section.classList.add('nutrima-reveal');
      seen.observe(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
